function isLoading(state) {
  return state.isLoading;
}

function templates(state) {
  return state.templates;
}

function workOrderForm(state) {
  return state.workOrderForm;
}

function forms(state) {
  return state.forms;
}

function formsToBeRemoved(state) {
  return state.formsToBeRemoved;
}

function workOrderFormId(state) {
  return state.workOrderFormId;
}

const FormGetters = {
  isLoading,
  templates,
  workOrderForm,
  forms,
  formsToBeRemoved,
  workOrderFormId,
};

export default FormGetters;
